import { render } from "./DepositConfigurationForm.vue?vue&type=template&id=ab16c68a"
import script from "./DepositConfigurationForm.vue?vue&type=script&lang=js"
export * from "./DepositConfigurationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__